import React from 'react';
import moment from 'moment-timezone';
import { RelativeWrapper, AmazonContext } from './CustomerContext.styles';
import * as colors from 'components/common/colorConstants';

export class CustomerContext extends React.Component {
  state = {
    isAmazonContextSectionActive: true,
    labelColor: colors.white,
  };

  toggleAmazonSection = () => {
    this.setState((currentState) => ({
      isAmazonContextSectionActive: !currentState.isAmazonContextSectionActive,
      labelColor: currentState.isAmazonContextSectionActive ? colors.lightGray1 : colors.white,
    }));
  };

  renderVisitedPages(lastVisitedPages = []) {
    let recentLinks = lastVisitedPages.map(({ url, timestamp }) => {
      if (url && timestamp) {
        return (
          <li key={url}>
            <a className="link" href={url} target="_blank" rel="noreferrer">
              Link
            </a>
            {moment(new Date(timestamp).toISOString()).tz(moment.tz.guess()).format('MM/DD/YY hh:mm a z')}
          </li>
        );
      }

      return null;
    });
    recentLinks = recentLinks.filter((link) => !!link);
    if (recentLinks.length < 1) {
      return;
    }

    return (
      <div>
        <p>Last visited pages:</p>
        <ul>{recentLinks}</ul>
      </div>
    );
  }

  render() {
    const amazonContext = this.props.customerContext;

    return (
      <RelativeWrapper>
        {amazonContext && (
          <AmazonContext>
            <div>
              <label style={{ color: this.state.labelColor }} clickable={true} onClick={this.toggleAmazonSection}>
                CUSTOMER INFO
              </label>
              <img
                clickable={true}
                onClick={this.toggleAmazonSection}
                className={this.state.isAmazonContextSectionActive ? 'up-arrow' : 'down-arrow'}
                src="/images/down-arrow-gray.svg"
                alt="open"
              />
            </div>

            <div
              highlight={this.state.isAmazonContextSectionActive}
              className={this.state.isAmazonContextSectionActive ? 'active' : 'inactive'}
            >
              <p>
                Prime Member: <span>{amazonContext.isPrimeMember ? 'Yes' : 'No'}</span>
              </p>
              <p>
                Postal Code: <span>{amazonContext.postalCode}</span>
              </p>

              {this.renderVisitedPages(amazonContext.lastVisitedPages)}

              <div>
                {amazonContext.productPage && (
                  <p>
                    Product Page:{' '}
                    <a className="product-page" href={amazonContext.productPage} target="_blank" rel="noreferrer">
                      {amazonContext.productPage}
                    </a>
                  </p>
                )}
              </div>
            </div>
          </AmazonContext>
        )}
      </RelativeWrapper>
    );
  }
}
